
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from "react-router-dom";

export const initSentry = () => {
  Sentry.init({
    dsn: "https://44e4e6dcfaf31731d0508bb6c4fee719@o4505091437232128.ingest.us.sentry.io/4509393634000896",
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
    environment: import.meta.env.MODE,
    beforeSend(event) {
      if (event.exception) {
        const error = event.exception.values?.[0];
        if (error?.type === "ChunkLoadError" || error?.value?.includes("Loading chunk")) {
          return null;
        }
      }
      return event;
    },
  });
};
